<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem to="/system/Jurisdiction">
            <Icon type="icon iconfont icon-quanxian" /> 多权限账户管理
          </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="md-add-circle" /> 新增权限 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="titlable">
          <span>新增权限</span>
        </div>

        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem prop="company_name">
            <Input v-model="formValidate.company_name" class="inptext" size="large" placeholder="请输入单位名" />
          </FormItem>
          <FormItem prop="account">
            <Input v-model="formValidate.account" class="inptext" size="large" placeholder="请输入账号" />
          </FormItem>
          <FormItem prop="password">
            <Input v-model="formValidate.password" class="inptext" size="large" placeholder="请输入密码" />
          </FormItem>
          <FormItem>
            <Button @click="backmast">返回</Button>
            <Button type="primary" style="margin-left: 32px" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 表单验证数据
      formValidate: {
        company_name: '', // 单位名
        account: '', // 账号
        password: '', // 密码
      },

      ruleValidate: {
        // 定义数据验证
        company_name: [{ required: true, message: '单位名不能为空!', trigger: 'blur' }],
        account: [{ required: true, message: '账号不能为空!', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空!', trigger: 'blur' }],
      },
    };
  },
  mounted() {},
  methods: {
    /**
     * 验证表单提交事件
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 运行提交方法
          this.addAccount();
        } else {
          this.$Message.error('失败!');
        }
      });
    },
    /**
     * 新增账号
     */
    addAccount() {
      const api = this.ApiUrl + 'user/addUser';
      const data = {
        unit_name: this.formValidate.company_name,
        account: this.formValidate.account,
        password: this.formValidate.password,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('添加成功!');

            // 返回主页
            setTimeout(() => {
              this.backmast();
            }, 1800);
          } else {
            this.$Message.error(res.data.extend.msg);
          }
        },
        res => {},
      );
    },

    // 返回主页
    backmast() {
      this.$router.push({
        path: '/system/Jurisdiction',
      });
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}

.titlable {
  height: 24px;
  border-left: 0.125rem solid #17233d;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;
}

.inptext {
  margin-top: 0.625rem;
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;
}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
}

.btnbox > button {
  margin-right: 200px;
}
</style>
